import { render, staticRenderFns } from "./IndexWinners.vue?vue&type=template&id=8d555604&scoped=true&"
import script from "./IndexWinners.vue?vue&type=script&lang=js&"
export * from "./IndexWinners.vue?vue&type=script&lang=js&"
import style0 from "./IndexWinners.vue?vue&type=style&index=0&id=8d555604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d555604",
  null
  
)

export default component.exports